const state = {
  placeh: {},
  userh: {}
}
const getters = {
  stateHPlace: state => state.placeh,
  stateHUser: state => state.userh,
  stateCardId: state => state.card_id,
}
const mutations = {
  setHPlace (state, place) {
    state.placeh = place
  },
  setHUser (state, user) {
    state.userh = user
  },
  setClearHistory (state) {
    Object.assign(state, {
      placeh: {},
      userh: {}
    })
  }
}
const actions = {
}
export default {
  state,
  getters,
  mutations,
  actions
}
